export default "/images/78e3a24a372deb52ecbc9ed31f4298ac.avif";